/**
 * コンバータ基本クラス
 */
export abstract class WprBaseConverter {
	// private 変数  ------------------------------------------------------------
	private m_Name: string		= null;			// コンバータ名称
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** コンバータ名称 */
	public get name():	string	{ return this.m_Name;	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(name: string) {
		this.m_Name = name;
	}
	// --------------------------------------------------------------------------

	// abstract メソッド  --------------------------------------------------------
	/**
	 * 値変換処理
	 * @param value 値
	 * @returns 変換後の値
	 */
	public abstract convert(value: any): string
	// --------------------------------------------------------------------------
}
